import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext({ settings: null, reload: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const timer = useRef(null);
  const tries = useRef(0);
  const reload = useCallback(() => {
    clearTimeout(timer.current);
    return api.get("/settings").then((r) => { tries.current = 0; setSettings(r.data); }).catch(() => {
      tries.current += 1;
      timer.current = setTimeout(reload, Math.min(2000 * tries.current, 15000));
    });
  }, []);
  useEffect(() => {
    reload();
    const again = () => { if (document.visibilityState === "visible") reload(); };
    window.addEventListener("online", reload);
    document.addEventListener("visibilitychange", again);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener("online", reload);
      document.removeEventListener("visibilitychange", again);
    };
  }, [reload]);
  return <SiteCtx.Provider value={{ settings, reload }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
